import { FC } from 'react';
import styles from './index.module.scss';
import nothingIcon from '@assets/images/vault/nothing.svg';
interface OwnProps {
  text?: string;
  className?: string;
}
const Nothing: FC<OwnProps> = ({ text, className }) => {
  return (
    <div className={`${styles.nothing} ${className}`}>
      <img src={nothingIcon} />
      {text ? <span>{text}</span> : null}
    </div>
  );
};

export default Nothing;
